/**
 * Maps token keys to their valid values.
 *
 * @internal
 */
export const CMCD_TOKEN_VALUES: Record<string, readonly string[]> = {
	e: ['bc', 'ps', 'pr', 'e', 't', 'c', 'b', 'm', 'um', 'pe', 'pc', 'rr', 'as', 'ae', 'abs', 'abe', 'sk', 'ce'] as const,
	ot: ['m', 'a', 'v', 'av', 'i', 'c', 'tt', 'k', 'o'] as const,
	sf: ['d', 'h', 's', 'o'] as const,
	st: ['v', 'l', 'll'] as const,
	sta: ['s', 'p', 'k', 'r', 'a', 'w', 'e', 'f', 'q', 'd'] as const,
}
